export interface PaidTiers {
  name: 'Pro';
  description: string;
  features: string[];
  priceId: { month: string; year: string };
}

function envString(value: string | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function proPriceIds(): { month: string; year: string } {
  return {
    month: envString(import.meta.env.VITE_PADDLE_PRO_PRICE_ID_MONTH),
    year: envString(import.meta.env.VITE_PADDLE_PRO_PRICE_ID_YEAR),
  };
}

export const paidPro: PaidTiers = {
  name: 'Pro',
  description:
    'Every agent in Exis, and Autocomplete and Repairer in Google Sheets.',
  features: [
    '10,000 cell edits each UTC month',
    'Oracle, Autocomplete, Repairer, Formatter, and Routines in the Exis editor',
    'One allowance across the Exis editor and Google Sheets',
  ],
  get priceId() {
    return proPriceIds();
  },
};
